export default __webpack_public_path__ + "5be5846a8a7966afb955c188ef912762.png";